module.exports = require("@trbl/react-html-element");